// removed by extract-text-webpack-plugin
module.exports = {"modalContentWrapper":"_1C_nsa827c3JbZ_hpEzwDI","modalContentHeader":"_2xDHkUDZ8h2ncZ7d6lX5Wt","modalContentBody":"_3BW7d0aOlGrAaioJinNunB","headerItem":"_2JX2L7Od2hkrbDyrpj2Mgq","headerItemText":"_27cbmng1yIStoTYglzIVa2","selected":"_2cJIkvXnvLVPE86gCAlXW2","closeButton":"_1GqImVsfcUkiLtchHrtMry","closeButtonContainer":"_3TcrYI6w-1ZuExPl9aGQcG","noBetsText":"_3rEvQ94AQCt2QS94Tg6G5F","closeButtonWrap":"_1vYhArysHQzKcYcJ1eFcrL"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/betHistory.css
// module id = 751
// module chunks = 0